import { Store } from '@betgames/bg-state-manager';

export const playerActivityStore = new Store<{ inactive: boolean; identity: string }>({
    key: 'PlayerActivity',
    default: {
        inactive: false,
        identity: '0',
    },
});
